<div class="modal-header border-0 px-lg-5 px-2">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-2 mt-3"
		>Ajout d'une prestation</span
	>
	<button
		type="button"
		class="btn-close"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="closeModal()"
	></button>
</div>

<div class="modal-body">
	<div class="container-fluid px-lg-5 px-2">
		<div class="row mb-4">
			<span class="theme-main-color fs-4 col">Informations</span>
		</div>
		<form id="formAjout" [formGroup]="formAjout">
			<!-- Date -->
			<div class="row my-4">
				<div class="col">
					<label
						for="inputDateFormation"
						class="form-label theme-main-color fw-bold"
						>Date de {{ LABEL_INTERVENTION }}</label
					>
					<input
						autocomplete="off"
						type="text"
						bsDatepicker
						class="form-control"
						id="inputDateFormation"
						formControlName="date"
						name="date"
						[ngClass]="{
							'is-invalid': date.invalid,
							'is-valid': date.dirty && date.valid
						}"
					/>
					<div
						*ngIf="
							date.invalid &&
							(date.dirty || date.touched || date.errors?.required)
						"
						class="invalid-feedback"
					>
						<span *ngIf="date.errors?.required">Une date est requise</span>
					</div>
				</div>
			</div>

			<!-- Horaire -->
			<div class="row my-4 d-flex justify-content-evenly">
				<div class="col-3 text-center">
					<label
						for="inputStartFormation"
						class="form-label theme-color fw-bold"
						>{{ isTWActive ? 'Horaire min.' : 'Heure début' }}</label
					>
					<timepicker
						[min]="minWorkingHourAsDate"
						[max]="maxWorkingHourAsDate"
						class="ms-3"
						id="inputStartFormation"
						[formControlName]="'readyTime'"
						[showMeridian]="false"
					></timepicker>
					<div *ngIf="readyTime.invalid" class="text-danger">
						<span *ngIf="readyTime.errors?.required"
							>Un horaire est requis</span
						>
						<span *ngIf="readyTime.errors['outOfRange']"
							>Veuillez saisir un horaire entre {{ MIN_WORKING_HOUR }}h et
							{{ MAX_WORKING_HOUR }}h</span
						>
					</div>
				</div>
				<div class="col-3 text-center">
					<label
						for="inputEndFormation"
						class="form-label theme-color fw-bold"
						>{{ isTWActive ? 'Horaire max.' : 'Heure fin' }}</label
					>
					<timepicker
						[min]="minWorkingHourAsDate"
						[max]="maxWorkingHourAsDate"
						class="ms-4"
						id="inputEndFormation"
						[formControlName]="'dueTime'"
						[showMeridian]="false"
					></timepicker>
					<div *ngIf="dueTime.invalid" class="text-danger">
						<span *ngIf="dueTime.errors?.required">Un horaire est requis</span>
						<span *ngIf="dueTime.errors['outOfRange']"
							>Veuillez saisir un horaire entre {{ MIN_WORKING_HOUR }}h et
							{{ MAX_WORKING_HOUR }}h</span
						>
					</div>
				</div>
				<div class="col-3 text-center" *ngIf="isTWActive">
					<label
						for="inputDurationFormation"
						class="form-label theme-color fw-bold"
						>Durée</label
					>
					<timepicker
						class="ms-4"
						id="inputDurationFormation"
						[formControlName]="'duration'"
						[showMeridian]="false"
					></timepicker>
					<div *ngIf="duration.invalid" class="text-danger">
						<span *ngIf="duration.errors?.required">Une durée est requise</span>
						<span *ngIf="duration.errors['outOfRange']"
							>Veuillez saisir une durée entre {{ MIN_WORKING_HOUR }}h et
							{{ MAX_WORKING_HOUR }}h</span
						>
					</div>
				</div>
				<div
					*ngIf="
						formAjout.errors &&
						(formAjout.errors.endBeforeStart || formAjout.errors.tooManyHours)
					"
					class="row my-2 text-center"
				>
					<span *ngIf="formAjout.errors.endBeforeStart" class="text-danger"
						>Veuillez saisir une heure de début inférieure à l'heure de
						fin</span
					>
					<span *ngIf="formAjout.errors.tooManyHours" class="text-danger"
						>La durée de la {{ LABEL_INTERVENTION }} ne peut excéder
						{{ MAX_DURATION }}h</span
					>
				</div>
			</div>

			<!-- Mission Type + Speciality -->
			<div class="row my-4">
				<div class="col-6">
					<label
						for="inputTypeFormation"
						class="form-label theme-main-color fw-bold"
						>Type de {{ LABEL_INTERVENTION }}</label
					>
					<input
						autocomplete="off"
						(keyup)="typeFormationKeyUp($event.target)"
						formControlName="missionType"
						[typeahead]="listMissionType"
						typeaheadOptionField="type"
						[typeaheadMinLength]="0"
						placeholder="Saisissez une {{ LABEL_INTERVENTION }}"
						class="form-control"
						[typeaheadScrollable]="true"
						(typeaheadOnSelect)="typeaheadTypeFormationOnSelect($event)"
						[ngClass]="{
							'is-invalid': missionType.errors?.required || !selectedMissionType
						}"
					/>
					<div
						*ngIf="
							(missionType.invalid &&
								(missionType.dirty ||
									missionType.touched ||
									missionType.errors?.required)) ||
							!selectedMissionType
						"
						class="text-danger"
					>
						<span *ngIf="missionType.errors?.required || !selectedMissionType"
							>Le choix d'un type de {{ LABEL_INTERVENTION }} est requis</span
						>
					</div>
				</div>
				<div
					class="col-6"
					*ngIf="
						!isReunion && (isSESSAD || isSAAD || isSAE) && !isAPrescription
					"
				>
					<label
						for="inputSpeciality"
						class="form-label theme-main-color fw-bold"
						>Spécialité de la {{ LABEL_INTERVENTION }}</label
					>
					<input
						autocomplete="off"
						(keyup)="specialityKeyUp($event.target)"
						formControlName="careSpecialty"
						[typeahead]="listCareSpecialty"
						typeaheadOptionField="name"
						[typeaheadItemTemplate]="itemTemplateTypeaheadSpeciality"
						[typeaheadMinLength]="0"
						placeholder="Saisissez une spécialité"
						class="form-control"
						[typeaheadScrollable]="true"
						(typeaheadOnSelect)="typeaheadSpecialityOnSelect($event)"
						[ngClass]="{
							'is-invalid':
								formAjout.errors?.careSpecialtyRequired || !careSpecialty.valid,
							'is-valid':
								careSpecialty.dirty &&
								careSpecialty.valid &&
								!formAjout.errors?.careSpecialtyRequired
						}"
					/>
					<ng-template
						#itemTemplateTypeaheadSpeciality
						let-model="item"
						let-index="index"
					>
						<span>{{ model.name }}</span>
					</ng-template>
					<div
						*ngIf="
							(careSpecialty.invalid &&
								(careSpecialty.dirty ||
									careSpecialty.touched ||
									careSpecialty.errors?.required)) ||
							!selectedCareSpecialty
						"
						class="text-danger"
					>
						<span
							*ngIf="
								careSpecialty.errors?.required ||
								formAjout.errors?.careSpecialtyRequired
							"
							>Le choix d'une spécialité est requis</span
						>
					</div>
				</div>
			</div>

			<div class="row my-4">
				<div class="col-6">
					<label
						for="inputParcours"
						class="form-label theme-main-color fw-bold"
						>Dossier DH</label
					>
					<input
						autocomplete="off"
						(keyup)="parcoursKeyUp($event.target)"
						formControlName="parcoursId"
						placeholder="Dossier DH rattaché"
						[typeahead]="listParcoursMapped"
						typeaheadOptionField="name"
						[typeaheadItemTemplate]="itemTemplateTypeaheadParcours"
						[typeaheadMinLength]="0"
						class="form-control"
						[typeaheadScrollable]="true"
						(typeaheadOnSelect)="typeaheadParcoursOnSelect($event)"
						[ngClass]="{
							'is-invalid':
								formAjout.errors?.parcoursRequired || !parcoursId.valid,
							'is-valid':
								parcoursId.dirty &&
								parcoursId.valid &&
								!formAjout.errors?.parcoursRequired
						}"
					/>
					<ng-template
						#itemTemplateTypeaheadParcours
						let-model="item"
						let-index="index"
					>
						<span>{{ model.name }}</span>
					</ng-template>
					
				</div>
				<div class="col-6">
					<label for="model" class="form-label theme-main-color fw-bold">Service</label>
					<input
						class="form-control"
						autocomplete="off"
						formControlName="centerDepartment"
						placeholder="Saisissez un service"
						[typeahead]="centerDepartments"
						[typeaheadOptionField]="'name'"
						[typeaheadMinLength]="0"
						[typeaheadScrollable]="true"
						(typeaheadOnSelect)="typeaheadCenterDepartmentOnSelect($event)"
						(keyup)="centerDepartmentsKeyUp($event.target)"
						[ngClass]="{
							'is-valid':
								(centerDepartment.dirty || centerDepartment.touched) &&
								centerDepartment.valid &&
								selectedCenterDepartment
						}"
					/>
				</div>
			</div>

			<!-- Bénéficiaire + Checkbox Domicile -->
			<div class="row my-4">
				<div class="col-6" *ngIf="shouldDisplayBeneficiaire()">
					<label
						for="inputBeneficiaire"
						class="form-label theme-main-color fw-bold"
						>{{ LABEL_BENEFICIAIRE | titlecase }}</label
					>
					<input
						autocomplete="off"
						(keyup)="beneficiaireKeyUp($event.target)"
						formControlName="beneficiaire"
						[typeahead]="listBeneficiaireMapped"
						typeaheadOptionField="name"
						[typeaheadItemTemplate]="itemTemplateTypeaheadBeneficiaire"
						[typeaheadMinLength]="0"
						placeholder="{{ LABEL_BENEFICIAIRE | titlecase }}"
						class="form-control"
						[typeaheadScrollable]="true"
						(typeaheadOnSelect)="typeaheadBeneficiaireOnSelect($event)"
						[ngClass]="{
							'is-invalid':
								formAjout.errors?.beneficiaireRequired || !beneficiaire.valid,
							'is-valid':
								beneficiaire.dirty &&
								beneficiaire.valid &&
								!formAjout.errors?.beneficiaireRequired
						}"
					/>
					<ng-template
						#itemTemplateTypeaheadBeneficiaire
						let-model="item"
						let-index="index"
					>
						<span>{{ model.name }}</span>
					</ng-template>
					<div
						*ngIf="
							(beneficiaire.invalid &&
								(beneficiaire.dirty ||
									beneficiaire.touched ||
									beneficiaire.errors?.required)) ||
							!selectedBeneficiaire
						"
						class="text-danger"
					>
						<span
							*ngIf="
								beneficiaire.errors?.required ||
								formAjout.errors?.beneficiaireRequired
							"
							>Le choix d'un {{ LABEL_BENEFICIAIRE }} est requis</span
						>
					</div>
				</div>
				<div *ngIf="displayBeneficiaireLocation()" class="col-6">
					<div class="row">
						<label
							class="form-label theme-main-color fw-bold"
							for="checkMissionPlaceBeneficiaire"
						>
							{{ LABEL_INTERVENTION | titlecase }} au domicile du
							{{ LABEL_BENEFICIAIRE }}
						</label>
					</div>
					<div class="row">
						<div
							class="form-check d-flex justify-content-center align-items-center"
							id="checkMissionPlaceBeneficiaire"
						>
							<input
								(change)="resetMissionPlace()"
								class="form-check-input theme-main-border-color fs-5"
								[ngClass]="{
									'theme-main-color-check': isMissionPlaceBeneficiaireAddress
								}"
								type="checkbox"
								formControlName="isMissionPlaceBeneficiaireAddress"
							/>
							<span *ngIf="isAlertAddressBeneficiaireNeeded()">
								<span class="fw-bold theme-red-color"
									>L'adresse du {{ LABEL_BENEFICIAIRE }} choisi est incorrecte
								</span>
								<a
									(click)="closeModal()"
									[routerLink]="[
										'/gestion/beneficiaires/',
										selectedBeneficiaire.id
									]"
									class="theme-main-color"
									>modifier</a
								>
							</span>
						</div>
					</div>
				</div>
			</div>

			<!-- Lieu + Checkbox Visio -->
			<div class="row my-4" *ngIf="!isMissionPlaceBeneficiaireAddress">
				<div *ngIf="isRemote" class="col-6">
					<div class="alert alert-secondary" role="alert">
						<p class="theme-main-color">
							<i class="bi bi-info-circle me-2" aria-hidden="true"></i>
							<em
								>Le lien de la visio sera consultable après la validation du
								formulaire.</em
							>
						</p>
					</div>
				</div>
				<div
					class="col-6"
					*ngIf="
						!isReunion &&
						(isSESSAD || isSAE) &&
						!isMissionPlaceBeneficiaireAddress &&
						(isAPrescription || !isRemote)
					"
				>
					<label
						for="inputMissionPlace"
						class="form-label theme-main-color fw-bold"
						>Lieu de {{ LABEL_INTERVENTION }}</label
					>
					<input
						autocomplete="off"
						(keyup)="missionPlaceKeyUp($event.target)"
						formControlName="missionPlace"
						[typeahead]="listMissionPlace"
						typeaheadOptionField="nameDisplay"
						[typeaheadItemTemplate]="itemTemplateTypeaheadMissionPlace"
						[typeaheadMinLength]="0"
						placeholder="{{
							isAPrescription ? 'Visio' : 'Saisissez un lieu de prestation'
						}}"
						class="form-control"
						[typeaheadScrollable]="true"
						(typeaheadOnSelect)="typeaheadMissionPlaceOnSelect($event)"
						[ngClass]="{
							'is-invalid':
								!isAPrescription &&
								(formAjout.errors?.missionPlaceRequired || !missionPlace.valid),
							'is-valid':
								isAPrescription ||
								(missionPlace.dirty &&
									missionPlace.valid &&
									!formAjout.errors?.missionPlaceRequired)
						}"
					/>
					<ng-template
						#itemTemplateTypeaheadMissionPlace
						let-model="item"
						let-index="index"
					>
						<span>{{ model.nameDisplay }}</span>
					</ng-template>
					<div
						*ngIf="
							(missionPlace.invalid &&
								(missionPlace.dirty ||
									missionPlace.touched ||
									missionPlace.errors?.required)) ||
							selectedMissionPlace === null
						"
						class="text-danger"
					>
						<span
							*ngIf="
								formAjout.errors?.missionPlaceRequired ||
								missionPlace.errors?.required
							"
							>Le choix d'un lieu de prestation est requis</span
						>
					</div>
				</div>
				<div *ngIf="!isAPrescription" class="col-6">
					<div class="row">
						<label class="form-label theme-main-color fw-bold" for="checkRemote"
							>{{ LABEL_INTERVENTION | titlecase }} à distance</label
						>
					</div>
					<div class="row">
						<div
							class="form-check d-flex justify-content-center align-items-center"
							id="checkRemote"
						>
							<input
								(change)="resetMissionPlace()"
								class="form-check-input theme-main-border-color fs-5"
								[ngClass]="{ 'theme-main-color-check': isRemote }"
								type="checkbox"
								formControlName="isRemote"
							/>
						</div>
					</div>
				</div>
			</div>

			<!-- Compétence + Temps de Prépa -->
			<div class="row my-4">
				<div
					*ngIf="formAjout.contains('competences') && !isReunion"
					class="col-6 col-lg"
				>
					<label for="competences" class="form-label fw-bold"
						>Compétence(s)</label
					>
					<div class="row">
						<div
							*ngFor="
								let competence of listCompetences | orderBy : 'name' : 'asc';
								let i = index
							"
						>
							<span class="col check">
								<input
									[type]="'checkbox'"
									[id]="competence.id"
									name="{{ competence }}"
									class="form-check-input"
									[value]="competence"
									[checked]="isCompetenceCheck(competence)"
									[ngClass]="{
										'theme-main-color-check': isCompetenceCheck(competence)
									}"
									[disabled]="
										isProfessionnelSAE ||
										(isSAE && isCompetencesElementaires(competence))
									"
									(change)="updateSelectedCompetence($event, competence)"
								/>
								<label
									[for]="competence.id"
									class="ms-2 form-check-label text-dark"
									>{{ competence.name.replaceAll('_', ' ') }}</label
								>
							</span>
						</div>
					</div>
				</div>
				<div class="row my-4" *ngIf="!isReunion && isSESSAD">
					<div class="col-12">
						<label
							for="inputEmployee"
							class="form-label theme-main-color fw-bold"
							>Temps de préparation:</label
						>
						<select
							class="form-select form-control"
							id="preparationTimePercentage"
							[formControlName]="'preparationTimePercentage'"
							aria-label="Temps de préparation"
						>
							<option
								*ngFor="let preparationTime of preparationTimeList"
								value="{{ preparationTime.time }}"
							>
								{{ preparationTime.label }} ({{ preparationTime.time }}%)
							</option>
						</select>
					</div>
				</div>
			</div>

			<div class="row my-4 mb-1">
				<div *ngIf="!isAPrescription && selectedBeneficiaire" class="col-6">
					<div class="row">
						<label class="form-label theme-main-color fw-bold" for="checkRemote"
							>Rappel automatique par email au {{ LABEL_BENEFICIAIRE }}</label
						>
					</div>
					<div class="row">
						<div
							class="form-check d-flex justify-content-center align-items-center"
							id="checkReminder"
						>
							<input
								class="form-check-input theme-main-border-color fs-5"
								[ngClass]="{ 'theme-main-color-check': remind }"
								type="checkbox"
								formControlName="remind"
							/>
						</div>
					</div>
				</div>
			</div>

			<!-- Participants -->
			<div class="row my-4 mb-1" *ngIf="!isSAE">
				<div class="col">
					<p class="form-label theme-main-color fw-bold">
						{{ LABEL_INTERVENANT_CAPITALIZED_PLURALIZED }}
					</p>
					<div class="input-group mb-3" *ngIf="!isReunion">
						<span class="input-group-text" id="basic-addon1">Nombre :</span>
						<input
							type="number"
							min="1"
							[max]="maxIntervenantSelectableForMission"
							class="form-control"
							[formControlName]="'nombreIntervenants'"
							aria-label="Nombre d'intervenants"
							(change)="checkValidityOfNumberOfEmployee()"
						/>
						<span class="input-group-text fw-bold"
							>(maximum : {{ maxIntervenantSelectableForMission }} )</span
						>
					</div>
					<div
						class="alert alert-warning mb-4"
						role="alert"
						*ngIf="!isNumberOfIntervenantSelectedValid && !isReunion"
					>
						Valeur incorrecte ! Le nombre d'intervenant sélectionné doit être
						inférieur ou égal au maximum imposé, et supérieur ou égal à 0.
					</div>
					<div
						class="alert alert-warning mb-4"
						role="alert"
						*ngIf="!isNumberOfIntervenantInputValid && !isReunion"
					>
						Valeur incorrecte ! Le nombre d'intervenant sélectionné doit être
						inférieur ou égal au nombre que vous avez inscrit ci-dessus.
					</div>
					<div class="mb-4">

                        <!-- HTML (fichier `formations-modal-ajout-form.component.html`) -->
                        <form [formGroup]="formAjout">
                            <div formArrayName="participants">
                                <div
                                        *ngFor="let ctrl of participants.controls; let i = index"
                                        [formGroupName]="i"
                                        class="d-flex align-items-center justify-content-between p-2 border rounded"
                                >
                                  <span class="col-3 m-2 theme-main-color">
                                    {{ selectedEmployeesForMission[i].firstName + ' ' + selectedEmployeesForMission[i].lastName }}
                                  </span>

                                    <div class="col-6 d-flex align-items-center justify-content-between p-2 border rounded">
                                        <label class="form-label theme-main-color" [attr.for]="'checkMissionPlaceIntervenant-' + i">
                                            Départ depuis le domicile: <br> {{ !isAlertAdressIntervenantNeeded(selectedEmployeesForMission[i], i) ? selectedEmployeesForMission[i].address.label : '' }}
                                        </label>

                                        <div class="form-check d-flex justify-content-center align-items-center mx-3 mb-3" [attr.id]="'checkMissionPlaceIntervenant-' + i">
                                            <input
                                                    (change)="resetMissionPlace()"
                                                    class="form-check-input theme-main-border-color fs-5"
                                                    type="checkbox"
                                                    [id]="'checkMissionPlaceIntervenant-' + i"
                                                    formControlName="isMissionPlaceIntervenantAddress"
                                            />
                                        </div>

                                        <span *ngIf="isAlertAdressIntervenantNeeded(selectedEmployeesForMission[i], i)">
                                          <span class="fw-bold theme-red-color">L'adresse de l' {{ LABEL_INTERVENANT }} choisi est incorrecte</span>
                                          <a (click)="closeModal()" [routerLink]="['/gestion/employees/', selectedEmployeesForMission[i].id]" class="theme-main-color">modifier</a>
                                        </span>
                                    </div>

                                    <button
                                            class="btn-sm"
                                            (click)="removeParticipant(selectedEmployeesForMission[i])"
                                            [ngClass]="{
                                            'theme-red-button':
                                            isReunion ||
                                            (!isReunion && this.formAjout.value.nombreIntervenants >= 0)
								        }"
                                    >
                                        <i
                                                class="bi bi-x-lg"
                                                *ngIf="
                                                isReunion ||
                                                (!isReunion && this.formAjout.value.nombreIntervenants >= 0)
                                            "
                                                aria-hidden="true"
                                        ></i>
                                    </button>
                                </div>
                            </div>
                        </form>

                        <!--<span class="d-flex flex-column gap-2">
                            <span
                                    class="d-flex align-items-center justify-content-between p-2 border rounded"
                                    *ngFor="let p of selectedEmployeesForMission; let i = index"
                            >
							<span class="m-2 theme-main-color">{{
								p.firstName + ' ' + p.lastName
							}}</span>
                                <div *ngIf="displayIntervenantsSelection()" class="col-6">
                                <div class="row">
                                    <label
                                            class="form-label theme-main-color fw-bold"
                                            [attr.for]="'checkMissionPlaceIntervenant-' + i"
                                    >
                                        Départ domicile de l'
                                        {{ LABEL_INTERVENANT_CAPITALIZED_PLURALIZED }}
                                    </label>
                                </div>
                                <div class="row">
                                    <div
                                            class="form-check d-flex justify-content-center align-items-center"
                                            [attr.id]="'checkMissionPlaceIntervenant-' + i"
                                    >
                                        <input
                                                (change)="resetMissionPlace()"
                                                class="form-check-input theme-main-border-color fs-5"
                                                [ngClass]="{
                                        'theme-main-color-check': isMissionPlaceIntervenantAddress
                                    }"
                                                type="checkbox"
                                                formControlName="isMissionPlaceIntervenantAddress"
                                        />
                                        <span *ngIf="isAlertAdressIntervenantNeeded(p,i)">
                                    <span class="fw-bold theme-red-color"
                                    >L'adresse du {{ LABEL_BENEFICIAIRE }} choisi est incorrecte
                                    </span>
                                            &lt;!&ndash;                                     doit modifier la route&ndash;&gt;
                                    <a
                                            (click)="closeModal()"
                                            [routerLink]="[
                                            '/gestion/beneficiaires/',
                                            selectedIntervenants.id
                                        ]"
                                            class="theme-main-color"
                                    >modifier</a
                                    >
                                </span>

                                        </div>
                                    </div>
                                </div>
							<button
								class="btn-sm"
								(click)="removeParticipant(p)"
								[ngClass]="{
									'theme-red-button':
										isReunion ||
										(!isReunion && this.formAjout.value.nombreIntervenants >= 0)
								}"
							>
								<i
									class="bi bi-x-lg"
									*ngIf="
										isReunion ||
										(!isReunion && this.formAjout.value.nombreIntervenants >= 0)
									"
									aria-hidden="true"
								></i>
							</button>

                            </span>
                        </span>-->
					</div>

                    <div
						class="row mt-2"
						*ngIf="
							isReunion ||
							(isNumberOfIntervenantSelectedValid &&
								numberOfIntervenantsSelected <
									maxIntervenantSelectableForMission &&
								numberOfIntervenantsSelected <
									this.formAjout.value.nombreIntervenants)
						"
					>
						<div class="col-7">
							<input
								*ngIf="user?.role.id !== Authority.CHARGE_MISSION"
								autocomplete="off"
								formControlName="employee"
								[typeahead]="listEmployeeMapped"
								typeaheadOptionField="name"
								[typeaheadItemTemplate]="itemTemplateTypeaheadEmployeeReunion"
								[typeaheadMinLength]="0"
								[placeholder]="messageInviteIntervenantParticipant"
								class="form-control"
								[typeaheadScrollable]="true"
								(typeaheadOnSelect)="
									typeaheadEmployeeOnSelectForMissionWithMultipleEmployee(
										$event
									)
								"
								[(ngModel)]="selectedParticipant"
								[typeaheadOptionsLimit]="30"
							/>
							<ng-template
								#itemTemplateTypeaheadEmployeeReunion
								let-model="item"
								let-index="index"
							>
								<span *ngIf="user?.role.id !== Authority.CHARGE_MISSION">{{
									model.name
								}}</span>
							</ng-template>
						</div>
						<div class="col d-flex justify-content-evenly">
							<button
								type="button"
								class="btn theme-main-color-button"
								(click)="selectAllParticipants()"
								*ngIf="isReunion"
							>
								Tous
							</button>
							<button
								type="button"
								class="btn theme-main-color-button"
								(click)="resetParticipantsReunion()"
								*ngIf="isReunion"
							>
								Effacer la liste
							</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Employés Disponibles SAE -->
			<div
				class="row mt-2"
				*ngIf="isSAE && !isProjectManager && !isProfessionnelTerrain"
			>
				<app-list-available-employees
					[date]="formAjout.get('date').value"
					[readyTime]="formAjout.get('readyTime').value"
					[dueTime]="formAjout.get('dueTime').value"
					[careSkills]="getCareSkills()"
					[missionType]="selectedMissionType"
					[specialty]="selectedCareSpecialty"
					[address]="getMissionLocation()"
					[isRemote]="isRemote"
					(selectedEmployeeEmitter)="selectEmployee($event)"
				>
				</app-list-available-employees>
			</div>

			<!-- Notes -->
			<div class="row my-4">
				<div class="col">
					<label for="inputNotes" class="form-label theme-main-color fw-bold"
						>Notes</label
					>
					<textarea
						class="form-control"
						id="inputNotes"
						formControlName="notes"
						[ngClass]="{
							'is-invalid': notes.invalid,
							'is-valid': notes.dirty && notes.valid
						}"
					></textarea>
					<div
						*ngIf="notes.invalid && (notes.dirty || notes.touched)"
						class="invalid-feedback"
					>
						<span *ngIf="notes.errors?.maxlength"
							>Taille maximale atteinte</span
						>
					</div>
				</div>
			</div>

			<!-- Répétition Formation -->
			<div class="row my-5" *ngIf="!isReunion">
				<div class="form-check form-switch">
					<input
						type="checkbox"
						class="form-check-input theme-main-border-color"
						id="customSwitch1"
						[checked]="isEventRecurring"
						(change)="onSwitchRecurrencyChange()"
						[ngClass]="{ 'theme-main-color-check': isEventRecurring }"
					/>
					<label class="form-check-label" for="customSwitch1"
						>Répéter la {{ LABEL_INTERVENTION }}</label
					>
				</div>
				<div *ngIf="isEventRecurring">
					<app-recurring-event-picker
						[startDate]="dateAsDate"
						(datesList)="updateDateList($event)"
					></app-recurring-event-picker>
				</div>
			</div>

			<!-- Boutons -->
			<div class="row my-5">
				<div class="d-flex justify-content-end">
					<button
						class="btn theme-main-color-button mx-3 px-3"
						type="button"
						(click)="closeModal()"
					>
						Retour
					</button>
					<button
						[disabled]="shouldSubmitButtonBeDisabled()"
						class="btn theme-green-button"
						type="submit"
						form="formAjout"
						(click)="onSubmit()"
					>
						<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
					</button>
				</div>
			</div>
		</form>
	</div>
</div>
